import React, { useEffect, useState } from "react"
import { useWallet } from "../libs/useMetaMaskWallet"
import Web3 from "web3"
import BreadCrumb from "../Components/BreadCrumb"
import ConnectWallet from "../Components/ConnectWallet"
import vestingAbi from "../../src/abi/VestingERC20.json"
import { Button, Card, CardBody, CardText, CardTitle, Col, FormGroup, Input, Label, Row, Table } from "reactstrap"
import { avgGasPrice } from "../utils"

const Token = () => {
    const web3 = new Web3(window.ethereum || window.web3)
    const [vestingContract, setVestingContract] = useState(null)
    const [availableClaimAmount, setAvailableClaimAmount] = useState("0")
    const [claimingAmount, setClaimingAmount] = useState("0")
    const [vestedAmount, setVestedAmount] = useState("0")
    const [totalAmount, setTotalAmount] = useState("0")
    const [isConnectedToWallet, setIsConnectedToWallet] = useState(false)
    // const [vestingContractAddr, setVestingContractAddr] = useState("")
    const wallet = useWallet()

    const withdrawTokens = async () => {
        if (!vestingContract) {
            alert("No Vesting Contract Detected!")
        } else if (isNaN(claimingAmount) || claimingAmount <= 0) {
            alert("Invalid claim amount!")
        } else if (Number(claimingAmount) > Number(availableClaimAmount)) {
            alert("You can not claim more than amount available!")
        } else {
            // The documentation on the RPC interface establishes a convention
            // that numbers be converted to Hexadecimals to avoid problems
            // with BN in some languages
            let gas = web3.utils.toHex(200000)
            let claimAmount = web3.utils.toWei(claimingAmount)
            try {
                await vestingContract.methods.claim(claimAmount).send({
                    from: wallet.account,
                    gas, // Gas Limit = maximum gas for this transaction
                    // gasPrice: await avgGasPrice()
                    type: "0x2",
                    maxFeePerGas: web3.utils.toHex(await avgGasPrice()), // maxFeePerGas = baseFeePerGas + maxPriorityFeePerGas
                    maxPriorityFeePerGas: web3.utils.toHex(1500000000) // like a "tip" to miner
                })
            } catch (error) {
                console.error("An error occurred when sending the transaction", error)
            }
        }
    }

    const updateConnection = () => {
        const x = wallet.status === "connected" && wallet.chainId === 1
        setIsConnectedToWallet(x)
        return x
    }

    useEffect(() => {
        async function fetchVesting() {
            const res = await fetch(`https://vesting.idexo.io/?wallet=${wallet.account}`)
            const json = await res.json()
            if (json?.data?.Items) {
                const contract = json.data.Items[0]?.contract?.S
                if (contract) {
                    let tokenContract = new web3.eth.Contract(vestingAbi["abi"], contract)
                    setVestingContract(tokenContract)
                }
            }
        }
        if (updateConnection() && wallet.account) {
            fetchVesting()
        }
    }, [wallet])

    useEffect(() => {
        ;(async () => {
            if (vestingContract) {
                const vestedAmountWei = await vestingContract.methods.getVestedAmount().call()
                const availableAmountWei = await vestingContract.methods.getAvailableClaimAmount().call()
                const totalAmountWei = await vestingContract.methods.totalAmount().call()
                setAvailableClaimAmount(web3.utils.fromWei(availableAmountWei))
                setClaimingAmount(web3.utils.fromWei(availableAmountWei))
                setVestedAmount(web3.utils.fromWei(vestedAmountWei))
                setTotalAmount(web3.utils.fromWei(totalAmountWei))
            }
        })()
    }, [vestingContract])

    return (
        <React.Fragment>
            <div className="content">
                <BreadCrumb items={["Vesting"]} />
                {!isConnectedToWallet ? (
                    <ConnectWallet wallet={wallet} chainId={1} onChange={updateConnection} />
                ) : (
                    <div className="vesting-body">
                        <Row>
                            <Col xs="12" lg={5}>
                                <Card>
                                    <CardBody>
                                        <CardTitle className="h3">Vesting Balance</CardTitle>
                                        <CardText className="P font-size-12 text-uppercase">Your IDO balance</CardText>

                                        <FormGroup className="mb-4 mt-4">
                                            <Label htmlFor="mobile-number" className="form-label">
                                                Available Now
                                            </Label>
                                            <CardText>{parseFloat(availableClaimAmount).toLocaleString()}</CardText>
                                        </FormGroup>

                                        <Row>
                                            <Col xs="6">
                                                <CardText className="P font-size-12 text-uppercase mb-1">VESTED</CardText>
                                                <CardText className="P font-size-14">
                                                    <span className="font-weight-semibold font-size-16">
                                                        {parseFloat(vestedAmount).toLocaleString()}
                                                    </span>
                                                </CardText>
                                            </Col>
                                            <Col xs="6">
                                                <CardText className="P font-size-12 text-uppercase mb-1">Allocation</CardText>
                                                <CardText className="P font-size-14">
                                                    <span className="font-weight-semibold font-size-16">
                                                        {parseFloat(totalAmount).toLocaleString()}
                                                    </span>
                                                </CardText>
                                            </Col>
                                        </Row>
                                    </CardBody>
                                </Card>

                                <Card>
                                    <CardBody>
                                        <CardTitle className="h3">Withdraw</CardTitle>
                                        <CardText className="P font-size-12 text-uppercase">Withdraw available balance</CardText>
                                        <Input
                                            type="number"
                                            className="form-control"
                                            value={claimingAmount}
                                            onChange={(e) => setClaimingAmount(e.target.value)}
                                        />

                                        <Button color="primary" className="waves-effect w-lg w-100 mt-2" onClick={withdrawTokens}>
                                            WITHDRAW {parseFloat(claimingAmount).toLocaleString()} IDO
                                        </Button>
                                    </CardBody>
                                </Card>
                            </Col>
                            <Col xs="12" lg={7}>
                                <Card>
                                    <CardBody>
                                        <CardTitle className="h3">Transactions</CardTitle>
                                        <CardText className="P font-size-12 text-uppercase">Your transaction history</CardText>

                                        <Table className="align-middle mb-0 table-nowrap">
                                            <thead className="table-light">
                                                <tr>
                                                    <th scope="col">Amount</th>
                                                    <th scope="col">Transaction Hash</th>
                                                    <th scope="col">Date</th>
                                                    <th scope="col">Status</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                            </tbody>
                                        </Table>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </div>
                )}
            </div>
        </React.Fragment>
    )
}

export default Token
